import { useEffect } from "react";
import { DEFAULT_EDITOR_TYPOGRAPHY } from "@caliu/types";
import { useUIStore } from "../store/ui";

/**
 * Applies the user's editor typography preferences to <html> as CSS
 * custom properties:
 *   --editor-body-size            (px)
 *   --editor-line-height          (unitless, the number the user picked)
 *   --editor-paragraph-spacing-scale  (unitless, the gap over the default 8px)
 *
 * `editor.css` reads these vars so the ProseMirror surface re-flows
 * without rebuilding the editor.
 */
export function useEditorTypography() {
  const typography = useUIStore((s) => s.editorTypography);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--editor-body-size", `${typography.size}px`);
    root.style.setProperty("--editor-line-height", String(typography.lineHeight));
    root.style.setProperty(
      "--editor-paragraph-spacing-scale",
      String(typography.paragraphSpacing / DEFAULT_EDITOR_TYPOGRAPHY.paragraphSpacing),
    );
  }, [typography]);
}
